import { useProductContext } from '../product-router/product-router';
import { useGenericFilters } from './filter-context/filter-context';
import { SITE_FILTER_TYPE_NAME, DEFAULT_OPTION } from './filter-types';

export const useCurrentProductHasFilters: () => boolean = () => {
	const { getActiveProduct } = useProductContext();
	const product = getActiveProduct();
	const { filterDefinitions } = useGenericFilters();

	return !!(product && filterDefinitions[product.id]?.length > 0);
};

export const useGetCurrentProductFilters: () => import('./filter-types').FilterDefinition<
	import('./filter-types').GenericFilterOption
>[] = () => {
	const { getActiveProduct } = useProductContext();
	const product = getActiveProduct();
	const { filterDefinitions } = useGenericFilters();

	return (product && filterDefinitions[product.id]) || [];
};

export const useCurrentProductHasAppliedFilters: () => boolean = () => {
	const filters = useGetCurrentProductFilters();
	let hasFilters = false;
	filters.forEach((filter) => {
		filter.store.availableFilters.forEach((option) => {
			if (option.isChecked && option.id !== DEFAULT_OPTION) {
				hasFilters = true;
			}
		});
	});
	return hasFilters;
};

export const useCurrentProductGenericSelectedFilterCount: () => number = () => {
	const filters = useGetCurrentProductFilters();
	const genericFilters = filters.filter((filter) => filter['@type'] !== SITE_FILTER_TYPE_NAME);
	return genericFilters.reduce(
		(filterCount, nextFilter) =>
			nextFilter.store.availableFilters.filter((f) => f.isChecked).length + filterCount,
		0,
	);
};
